import React from "react";
import DisplayChecker from "../../../../../components/wrappers/DisplayChecker";
import { useTranslation } from "react-i18next";
import { useFetch } from "../../../../../hooks/Fetching";
import { INFORMATION_FIELD_REQUEST } from "../../../../../enums/ApiPaths";
import { FormProvider, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import InformationFieldForm from "./components/InformationFieldForm";
import { useInformationFieldFormResolver } from "./utils/InformationFieldFormResolver";
import SingleInformationFieldFlip from "./components/SingleInformationFieldFlip";
import SimpleAlert from "../../../../../components/display/SimpleAlert";
import { INFO_FIELD } from "../../../../../enums/QueryKeys";
import Loader from "../../../../../components/loader/Loader";
import ErrorFullScreenMessage from "../../../../../components/fullScreenMessage/ErrorFullScreenMessage";
import PageContentWrapper from "../../../../../components/wrappers/PageContentWrapper";
import { useRedirectIfNotOwnClinic } from "../../../../../hooks/useRedirectIfNotOwnClinic";

const marginSides = 10;

export default function InformationFieldsPage() {
  const { t } = useTranslation();
  const { id: clinicId } = useParams();
  useRedirectIfNotOwnClinic(clinicId);
  const {
    data: informationFields,
    isLoading,
    error,
  } = useFetch(INFORMATION_FIELD_REQUEST, clinicId, INFO_FIELD);

  const methods = useForm({
    resolver: zodResolver(useInformationFieldFormResolver(t)),
  });

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return <ErrorFullScreenMessage />;
  }

  return (
    <PageContentWrapper>
      <Stack
        ml={{ xs: 0, sm: 0, md: marginSides }}
        mr={{ xs: 0, sm: 0, md: marginSides * 2 }}
      >
        <SimpleAlert severity={"info"} message={"InformationFieldsUserMessage"} />
        <FormProvider {...methods}>
          <InformationFieldForm />
        </FormProvider>
        {informationFields?.map((informationField) => (
          <SingleInformationFieldFlip
            key={informationField?.id}
            informationField={informationField}
          />
        ))}
      </Stack>
    </PageContentWrapper>
  );
}
